import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { AuthorizationService } from '../authorization/authorization.service';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ReloginDialogComponent } from 'src/app/Modules/General/Modals/Relogin/relogin-dialog/relogin-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root',
})
export class ApiIntercepterService implements HttpInterceptor {
  private auth = inject(AuthorizationService);
  dialog = inject(MatDialog);
  private toastr = inject(ToastrService);

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        auth: localStorage.getItem('rawToken'),
      },
      setParams: {
        requestedPartner: localStorage.getItem('partnerName'),
        userType: localStorage.getItem('userType') || 'external',
      },
    });

    return next.handle(request).pipe(
      tap(
        (evt) => {},
        (err) => {
          if (err.status >= 500 && err.status !== 504) {
            this.toastr.error(
              '',
              'Internal Server Error, Please try after some Time!'
            );
          }
          if (err.status !== 401 && err.status >= 400 && err.status < 500) {
            this.toastr.error(
              '',
              err.error.error ? err.error.error : err.error
            );
          }
          if (err.status === 504) {
            this.toastr.error(
              '',
              'Gateway Timeout, Please try after some Time!'
            );
          }
          if (err.status === 401 && !this.auth.reLoginDialogLoaded) {
            this.toastr.error('', err.error.message);
            this.dialog.open(ReloginDialogComponent, {
              width: '600px',
            });
          }
        }
      )
    );
  }
}
